export default __webpack_public_path__ + "static/media/ic_arrow_down_dark.37fca0e1.svg";